import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import Header from '../../Components/Header/header.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import Newpagination from '../../Components/Pagination/pagination.tsx';
import { FaFilePen } from "react-icons/fa6";
import EditVehicleModal from './edit-vehicle-modal.tsx';
import AddVehicleModal from './add-vehicle-modal.tsx';
import DocumentsModal from './documents-modal.tsx';
import '../../Components/Button/button-style.scss';
import StatusFilterTabs from '../../Components/Tab/tab.tsx';
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { SelectChangeEvent } from '@mui/material/Select';
import { getVehicle, getWarehouseCompanyMapping, getCurrentLocation, getCompanies, getWarehouses, getInstitutionVehicleMapping } from '../Vehicles/action.ts';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import DescriptionIcon from '@mui/icons-material/Description'; 
import EditIcon from '@mui/icons-material/Edit';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import SearchIcon from '@mui/icons-material/Search';
import formatDate from '../../Utils/DateFormat/date-format.tsx';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, TextField, Box, Typography, Tooltip, useTheme, useMediaQuery, Card, CardContent, InputAdornment } from '@mui/material';
import * as XLSX from 'xlsx';
import QueryWidget from '../../Components/QueryWidget/query-widget.tsx';
import { saveAs } from 'file-saver';

interface VehiclesProps { 
}

const Vehicles: React.FC<VehiclesProps> = (props) => {
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState<number>(10);
    const [page, setPage] = useState<number>(0);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [vehicleList, setVehicleList] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
    const [warehouseOptions, setWarehouseOptions] = useState<{id: string, label: string}[]>([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState<{ id: string, name: string } | null>(null);
    const [companyOptions, setCompanyOptions] = useState<{id: string, label: string}[]>([]);
    const [selectedCompany, setSelectedCompany] = useState<string>(() => {
    return localStorage.getItem('lastSelectedCompany') || '';
    });    
    const [searchTerm, setSearchTerm] = React.useState('');
    const [openModal, setOpenModal] = useState(false);
    const [refreshTable, setRefreshTable] = useState(false);
    const [documentsModal, setDocumentsModal] = useState(false);
    const [isAddVehicleOpen, setIsAddVehicleOpen] = useState(false);
    const [activeTab, setActiveTab] = useState<string>('Active');
    const [locationData, setLocationData] = useState<{[key: number]: string}>({});
    const [institutionData, setInstitutionData] = useState<{[key: number]: { driver: string, institution: string, institutionId: string, routeName: string, routeId: string }}>({});
    const [locationModalOpen, setLocationModalOpen] = useState(false);
    const [selectedLocationAddress, setSelectedLocationAddress] = useState<string>('');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const stmsCompany = companyOptions.find((c: any) => c.label.toUpperCase() === 'STMS');
    const isSTMSSelected = stmsCompany ? selectedCompany === String(stmsCompany.id) : false;

    const exportToExcel = () => {
        const worksheetData = vehicleList.map((vehicle: any, index: number) => {
            const instData = institutionData[vehicle.id];
            const mappedDriver = isSTMSSelected && instData?.driver ? instData.driver : vehicle?.driver_name;

            const dataRow: any = {
                'Sl No': (page * pageSize) + index + 1,
                'Vehicle Number': vehicle?.number_plate,
                'Model': vehicle?.make_model,
                'Owner': vehicle?.owner_name,
                'Driver': mappedDriver,
            };

            if (isSTMSSelected) {
                dataRow['Institution'] = instData?.institution || '';
                dataRow['Route Name'] = instData?.routeName || '';
            }

            dataRow['Fuel Type'] = vehicle?.fuel_type;
            return dataRow;
        });

        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Vehicles');
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        saveAs(new Blob([wbout], { type: 'application/octet-stream' }), 'vehicles_list.xlsx');
    };

    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const userRole = userDetailsFromStorage?.role?.toLowerCase();
    const companiesId= String(userDetailsFromStorage?.companies_id || '');
    const isPlatformUser = userRole === 'platform_tech' || userRole === 'platform_ops' || userRole === 'platform_finance';
    const roleFeatures = JSON.parse(localStorage.getItem('roleFeatures') || '[]');
    
    const hasFeature = (featureName: string) => {
        if (!roleFeatures) return false;
        const target = featureName.toLowerCase();
        const containsFeature = (arr: any[]) => arr.some((f: any) => 
            (typeof f === 'string' && f.toLowerCase() === target) ||
            (f?.name && f.name.toLowerCase() === target) ||
            (f?.feature && f.feature.toLowerCase() === target)
        );

        if (Array.isArray(roleFeatures)) {
            const configObj = roleFeatures.find(item => item && typeof item === 'object' && item.enabled);

            if (configObj) {
                if (configObj.enabled && Array.isArray(configObj.enabled) && containsFeature(configObj.enabled)) return true;
            }

            return containsFeature(roleFeatures);
        }

        if (typeof roleFeatures === 'object') {
            if (roleFeatures.enabled && Array.isArray(roleFeatures.enabled) && containsFeature(roleFeatures.enabled)) return true;
            return !!roleFeatures[featureName] || !!roleFeatures[target];
        }

        return false;
    };

    const hasWarehouseFeature = hasFeature('warehouse') || hasFeature('warehouses');
    const hasDriversFeature = hasFeature('drivers');

    const updateField = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        if (!isNaN(Number(value))) {
            setPageSize(Number(value));
            setPage(0);
        }
    };

    const handleCloseModal = () => {
        setPage(0);
        setRefreshTable(prev => !prev);
        setOpenModal(false);
        setSelectedVehicle(null);
    };

    const handleClickOpen = () => {
        setIsAddVehicleOpen(true);
    };

    const handleCloseAddVehicle = () => {
        setPage(0);
        setRefreshTable(prev => !prev);
        setIsAddVehicleOpen(false);
    };

   const processInstitutionMappingResponse = (res: any) => {
        setInstitutionData(prev => {
            const updatedMappings = { ...prev };
            const records = res.data || res.message?.institution_vehicles || res.message || [];
            const freshMappings: { [key: number]: { driver: string, institution: string, institutionId: string, routeName: string, routeId: string } } = {};
    
            if (Array.isArray(records)) {
                records.forEach((item: any) => {
                    const vId = item.vehicle_id || item.vehicle?.id;
                    if (vId) {
                        const newDriver = item.driver_name || item.driver?.first_name || item.driver?.name || '';
                        const newInstitution = item.institution_name || item.institution?.name || '';
                        const newInstitutionId = item.institution_id || item.institution?.id || '';
                        const newRouteName = item.route_code || item.route?.name || item.route_name || '';
                        const newRouteId = item.route_id || item.route?.id || '';
                        
                        if (freshMappings[vId]) {
                            freshMappings[vId] = {
                                driver: newDriver || freshMappings[vId].driver,
                                institution: newInstitution || freshMappings[vId].institution,
                                institutionId: newInstitutionId || freshMappings[vId].institutionId,
                                routeName: newRouteName || freshMappings[vId].routeName,
                                routeId: newRouteId || freshMappings[vId].routeId,
                            };
                        } else {
                            freshMappings[vId] = {
                                driver: newDriver,
                                institution: newInstitution,
                                institutionId: newInstitutionId,
                                routeName: newRouteName,
                                routeId: newRouteId,
                            };
                        }
                    }
                });
            }
            return { ...updatedMappings, ...freshMappings };
        });
    };

    useEffect(() => {
        setIsLoading(true);
        getVehicle(
        pageSize,
        page,
        (response: any) => {
            const vehicleDetails = response.message?.vehicles_list || [];

            setVehicleList((prev: any) => {
                if (isMobile && page > 0) {
                    const existingIds = new Set(prev?.map((v: any) => v.id) || []);
                    const newUnique = vehicleDetails.filter((v: any) => !existingIds.has(v.id));
                    return [...(prev || []), ...newUnique];
                }
                return vehicleDetails;
            });

            const totalVehiclesCount = response.message.total_vehicles_count;
            setTotalRecords(totalVehiclesCount);

            if (vehicleDetails.length > 0) {
                const vehicleIds = vehicleDetails.map((vehicle: any) => Number(vehicle.id));
                getCurrentLocation(
                    (response: any) => {
                        if (response.status === 200 && response.data) {
                            const locMap: {[key: number]: string} = {};
                            response.data.forEach((location: any) => {
                                locMap[location.vehicle_id] = location.geofence_name ? location.geofence_name : (location.address || '');
                            });
                            setLocationData(prev => ({ ...prev, ...locMap }));
                        }
                    },
                    (errMessage: any) => {
                        console.log('Error fetching locations:', errMessage);
                    },
                    vehicleIds
                );

                if (isSTMSSelected) {
                    getInstitutionVehicleMapping(
                        vehicleIds,
                        '', 
                        pageSize, 
                        0, 
                        processInstitutionMappingResponse,
                        (errMessage: any) => {
                            console.log('Error fetching institution mappings:', errMessage);
                        }
                    );
                }
            }
            setIsLoading(false);
        },
        (errMessage: any) => {
            toast.error(errMessage.message);
            setVehicleList([]);
            setTotalRecords(0);
            setIsLoading(false);
        },
        { active: activeTab === 'Inactive' ? 0 : 1 },
        '', 
        '', 
        selectedWarehouse?.name,
        '',
        selectedCompany || '',
        );
    }, [page, pageSize, selectedWarehouse, refreshTable, activeTab, isMobile, selectedCompany, isSTMSSelected]); 

    useEffect(() => {
        if (!hasWarehouseFeature) return;

        if (userRole === 'vendor_supervisor') {
            getWarehouses(
                0,      
                "100",
                "", 
                (response: any) => {
                    const list = response.message?.warehouses 
                        || response.data?.warehouses 
                        || (Array.isArray(response.message) ? response.message : null)
                        || (Array.isArray(response.data) ? response.data : []) 
                        || []; 

                    const options = list.map((warehouse: any) => ({
                        id: warehouse.id,
                        label: warehouse.name,
                    }));
                    setWarehouseOptions(options);
                },
                (errMessage: any) => { 
                    toast.error(typeof errMessage === 'string' ? errMessage : errMessage?.message || "Failed to fetch warehouses"); 
                }
            );
        } else {
            getWarehouseCompanyMapping(
                companiesId,
                (response: any) => {
                    const options = response.user_warehouses.map((warehouses: any) => ({
                        id: warehouses.warehouse.id,
                        label: warehouses.warehouse.name,
                    }));
                    setWarehouseOptions(options);
                },
                (errMessage: any) => {
                    toast.error(errMessage.message);
                }
            );
        }
    }, [companiesId, userRole, hasWarehouseFeature]);

   useEffect(() => {
    if ((userRole === 'platform_tech' || userRole === 'platform_ops' || userRole === 'platform_finance')) {
        getCompanies(
            100,
            0,
            null,
            (response: any) => {
                if (response.message && Array.isArray(response.message)) {
                    const companies = response.message.map((item: any) => ({
                        id: String(item.company.id),
                        label: item.company.name,
                    }));
                    setCompanyOptions(companies);
                    const savedCompanyId = localStorage.getItem('lastSelectedCompany');
                    const isSavedValid = companies.some((c: any) => c.id === savedCompanyId);

                    if (isSavedValid && savedCompanyId) {
                        setSelectedCompany(savedCompanyId);
                    } else {
                        const stmsCompanyFallback = companies.find((c: any) => c.label.toUpperCase() === 'STMS');
                        if (stmsCompanyFallback) {
                            setSelectedCompany(stmsCompanyFallback.id);
                            localStorage.setItem('lastSelectedCompany', stmsCompanyFallback.id);
                        } else if (companies.length > 0) {
                            setSelectedCompany(companies[0].id);
                            localStorage.setItem('lastSelectedCompany', companies[0].id);
                        }
                    }
                } else {
                    console.log('Unexpected response format:', response);
                }
            },
            (errMessage: any) => {
                console.log('Error fetching companies:', errMessage);
            }
        );
    }
}, [userRole, isAddVehicleOpen]);

    const showEntries = [
        {id:'10',  label:'10'},
        { id: '20', label: '20' },
        { id: '50', label: '50' },
        { id: '100', label: '100' },
    ];

    const handlePageClick = (event: React.ChangeEvent<unknown>, newPage: number) => {
        setPage(newPage - 1);
    };

    const handleInputChange = (event: any) => {
        const value = event.target.value;
        setSearchTerm(value);  
            if (value === '') {
            setPage(0);
            setRefreshTable(prev => !prev);
        }
    };

   const handleSearchClick = () => {
        setPage(0);
        getVehicle(
            pageSize,
            0,   
            (response: any) => {
                const vehicleDetails = response.message?.vehicles_list || [];
                setVehicleList(vehicleDetails);
                const totalVehiclesCount = response.message.total_vehicles_count;
                setTotalRecords(totalVehiclesCount);

                if (vehicleDetails.length > 0) {
                    const vehicleIds = vehicleDetails.map((vehicle: any) => Number(vehicle.id));

                    getCurrentLocation(
                        (res: any) => {
                            if (res.status === 200 && res.data) {
                                const locMap: {[key: number]: string} = {};
                                res.data.forEach((location: any) => {
                                    locMap[location.vehicle_id] = location.geofence_name ? location.geofence_name : (location.address || '');
                                });
                                setLocationData(prev => ({ ...prev, ...locMap }));
                            }
                        },
                        (errMessage: any) => {
                            console.log('Error fetching locations:', errMessage);
                        },
                        vehicleIds
                    );

                    if (isSTMSSelected) {
                        getInstitutionVehicleMapping(
                            vehicleIds,
                            '', 
                            pageSize, 
                            0, 
                            processInstitutionMappingResponse,
                            (errMessage: any) => {
                                console.log('Error fetching institution mappings:', errMessage);
                            }
                        );
                    }
                }
            },
            (errMessage: any) => {
                if(errMessage.message?.errors?.number_plate){
                    toast.error(errMessage.message?.errors?.number_plate[0])
                }
                else {
                    toast.error(errMessage.message);
                }
                setVehicleList('')
                setTotalRecords(0);
            },
            { active: activeTab === 'Inactive' ? 0 : 1 },
            searchTerm,
            '',
            selectedWarehouse?.name,
        );
    };

    const handleCloseDetailsModal = () => {
        setDocumentsModal(false);
        setSelectedVehicle(null);
    };

    const handleDocumentsClick = (vehicle: any) => {
        setSelectedVehicle(vehicle);
        setDocumentsModal(true);
    };

    // Inject mapped route details directly into modal props
    const handleEditClick = (row: any) => {
        const originalVehicle = vehicleList.find((v: any) => v.id === row.id);
        const instData = institutionData[row.id];
        
        const vehicleToEdit = {
            ...(originalVehicle || row),
            route_id: instData?.routeId || '',
            route_name: instData?.routeName || '',
            institution_id: instData?.institutionId || '',
            institution_name: instData?.institution || '',
        };

        setSelectedVehicle(vehicleToEdit);
        setOpenModal(true);
    };

    const handleTabChange = (newTab: string) => {
        setActiveTab(newTab);
        setPage(0);
    }

    const formatAddressToFourCommas = (address: string): string => {
        if (!address || address === '') return '';

        if (!address.includes(',')) return address;

        let parts = address.split(',').map(part => part.trim());
        const excludeKeywords = ['india', 'bengaluru', 'karnataka'];
        parts = parts.filter(part => {
            const lowerPart = part.toLowerCase();
            return !excludeKeywords.some(keyword => lowerPart.includes(keyword));
        });
        const lastFour = parts.slice(-4);

        return lastFour.join(', ');
    };

    const handleLocationIconClick = (row: any) => {
        const address = row.location || '';
        setSelectedLocationAddress(address);
        setLocationModalOpen(true);

        const stateData = { 
            tripId: row.id, 
            vehicleNo: row.vehicle_no, 
            vehiclesId: row.id, 
            driverName: row.driver, 
            startLat: 0, 
            startLng: 0, 
            endLat: 0, 
            endLng: 0, 
            startLocation: row.location, 
            endLocation: '', 
            deviceId: '', 
            orders: 0, 
            distance: 0, 
            status: '', 
            driverPhone: row.driver_phone,
            rawStartTime: '',
            vehicleList: vehicleList, 
            fromHistory: false,
            referrer: '/vehicles'
        };

        const stateKey = `trip_state_${Date.now()}`;
        localStorage.setItem(stateKey, JSON.stringify(stateData));

        navigate(`/trips/directions?stateKey=${stateKey}`, { state: stateData });
    };

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        if (!isMobile) return;
        const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

        if (scrollHeight - scrollTop <= clientHeight + 50) {
            const maxPage = Math.ceil(totalRecords / pageSize) - 1;
            if (!isLoading && page < maxPage) {
                setPage(prev => prev + 1);
            }
        }
    };

    const columns: GridColDef[] = [
        { field: 'sl_no', headerName: 'Sl No', width: 80, headerAlign: 'center' },
        { field: 'vehicle_no', headerName: 'Vehicle Number', width: 165, headerAlign: 'center' },
        { field: 'driver', headerName: 'Driver', width: 180, headerAlign: 'center' },
        ...(isSTMSSelected ? [
            { field: 'institution', headerName: 'Institution', width: 180, headerAlign: 'center' },
            { field: 'routeName', headerName: 'Route Name', width: 150, headerAlign: 'center' },

        ] as GridColDef[] : []),

        { 
            field: 'location', 
            headerName: 'Location', 
            width: 180, 
            headerAlign: 'center', 
            renderCell: (params: GridRenderCellParams) => {
                if (!params.row.location || params.row.location === '') {
                    return null;
                }

                return (
                    <div 
                        onClick={() => handleLocationIconClick(params.row)} 
                        style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            justifyContent: 'center', 
                            fontSize: '0.75rem', 
                            lineHeight: '1.4', 
                            padding: '4px 0', 
                            width: '100%',
                            cursor: 'pointer'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '4px', gap: '6px' }}>
                            <Tooltip title={'Current Location'}>
                                <LocationOnIcon 
                                    fontSize="small" 
                                    style={{ color: 'blue', marginTop: '2px', flexShrink: 0 }} 
                                />
                            </Tooltip>
                            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, wordBreak: 'break-word' }}>
                                <span style={{ fontWeight: 'bold', marginRight: '4px', fontSize: '0.7rem' }}>
                                    Current:
                                </span>
                                <span style={{ fontSize: '0.75rem', whiteSpace: 'normal' }}> 
                                    {formatAddressToFourCommas(params.row.location)}
                                </span>
                            </div>
                        </div>
                    </div>
                );
            }
        },
        { field: 'owner', headerName: 'Owner', width: 180, headerAlign: 'center' },
        { field: 'model', headerName: 'Model', width:120, headerAlign: 'center' },
        { field: 'fuel_type', headerName: 'Fuel Type', width: 140, headerAlign: 'center' },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 140, 
            headerAlign: 'center',
            renderCell: (params: GridRenderCellParams) => {
                const isOwnedByCompany = String(params.row.companies_id || '') === companiesId;
                return (
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            gap: '8px',
                        }}
                    >
                        <IconButton color="primary" onClick={() => handleDocumentsClick(params.row)}>
                            <DescriptionIcon /> 
                        </IconButton>

                        {(isOwnedByCompany || (userRole === 'platform_tech'&& isSTMSSelected)) && (
                            <IconButton color="primary" onClick={() => handleEditClick(params.row)}>
                                <EditIcon />
                            </IconButton>
                        )}
                    </div>
                );
            },
        }
    ];

    const handleWarehouseChange = (event: SelectChangeEvent<string>) => {
        const warehouseId = event.target.value;
        const warehouse = warehouseOptions.find(c => c.id === warehouseId);
        const transformedWarehouse = warehouse ? { id: warehouse.id, name: warehouse.label } : null;
        setSelectedWarehouse(transformedWarehouse);
    }

    const rows = vehicleList ? vehicleList.map((vehicle: any, index: number) => {
        const instData = institutionData[vehicle.id];

        return {
            id: vehicle.id,
            sl_no: (page * pageSize) + index + 1, 
            vehicle_no: vehicle?.number_plate,
            model: vehicle?.make_model,
            owner: vehicle?.owner_name,
            owner_phone: vehicle?.owner_phone,
            driver_phone: vehicle?.driver_phone,
            driver: isSTMSSelected && instData?.driver ? instData.driver : vehicle?.driver_name,
            institution: isSTMSSelected && instData?.institution ? instData.institution : '',
            routeName: isSTMSSelected && instData?.routeName ? instData.routeName : '',
            driver_id: vehicle?.driver_id,
            fuel_type: vehicle?.fuel_type,
            companies_id: vehicle?.companies_id,
            location: locationData[vehicle.id] || '',
        };
    }) : [];

    const MobileVehicleList = ({ rowData }: any) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px', p: 1, pb: '90px' }}>
            {rowData.map((row: any) => (
                <Card 
                    key={row.id} 
                    onClick={() => handleLocationIconClick(row)}
                    sx={{ 
                        borderRadius: '12px', 
                        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                        border: '1px solid #e0e0e0',
                        overflow: 'visible',
                        cursor: 'pointer'
                    }}>
                    <CardContent sx={{ pb: '12px !important', paddingTop:'10px !important', paddingLeft:'0 !important'}}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box display="flex" flexDirection="column" gap={0.5} flex={1} overflow="hidden">
                                <Box display="flex" alignItems="center" gap={1}>
                                    <LocationOnIcon sx={{ color: '#d32f2f' }} />
                                    <Typography 
                                        variant="subtitle1" 
                                        fontWeight="bold" 
                                        sx={{ whiteSpace: 'nowrap' }}
                                    >
                                        {row.vehicle_no}
                                    </Typography>
                                    <Box display="flex" flexDirection="column" sx={{ ml: 1, overflow: 'hidden' }}>
                                        <Typography 
                                            variant="body2" 
                                            sx={{ 
                                                whiteSpace: 'nowrap', 
                                                overflow: 'hidden', 
                                                textOverflow: 'ellipsis',
                                                color: 'black'
                                            }}
                                        >
                                            {row.driver || ''}
                                        </Typography>
                                        {isSTMSSelected && (
                                            <Typography 
                                                variant="caption" 
                                                sx={{ 
                                                    whiteSpace: 'nowrap', 
                                                    overflow: 'hidden', 
                                                    textOverflow: 'ellipsis',
                                                    color: 'text.secondary',
                                                    fontSize: '0.7rem'
                                                }}
                                            >
                                                {row.institution !== '' ? row.institution : ''}
                                                {row.routeName !== '' ? ` | Route: ${row.routeName}` : ''}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>

                                {(row.location && row.location !== '') && (
                                    <Box display="flex" alignItems="flex-start" gap={1} ml={4}>
                                        <Typography 
                                            variant="caption" 
                                            color="textSecondary"
                                            sx={{
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                            }}
                                        >
                                            {formatAddressToFourCommas(row.location)}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>

                            <Box display="flex" flexDirection="column" gap={0} alignItems="flex-end" ml={1}>
                                {(hasDriversFeature && row.driver_phone) && (
                                    <IconButton 
                                        size="small" 
                                        color="primary" 
                                        href={`tel:${row.driver_phone}`} 
                                        onClick={(e) => e.stopPropagation()} 
                                        sx={{ padding: '4px', scale: 1.2 }}
                                    >
                                        <PhoneIcon fontSize="small"  />
                                    </IconButton>
                                )}

                                <Box display="flex" flexDirection="row">
                                    {(String(row.companies_id || '') === companiesId) && (
                                        <IconButton 
                                            size="small" 
                                            color="primary" 
                                            onClick={(e) => { e.stopPropagation(); handleEditClick(row); }} 
                                            sx={{ padding: '4px', scale: 1.5 }}
                                        >
                                            <FaFilePen fontSize="small" />
                                        </IconButton>
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </CardContent>
                </Card>
            ))}
            {isLoading && isMobile && (
                <Typography variant="body2" color="textSecondary" align="center" sx={{ mt: 2 }}>
                    Loading more vehicles...
                </Typography>
            )}
        </Box>
    );

    if (isPlatformUser) {
        return (
            <>
                <Header />
                <div style={{ marginTop: "70px" }}>
                    <Heading
                        title="Vehicles"
                        page='vehicles'
                        closeIcon="false"
                        leftContent={
                            <>
                                <Box display="flex" alignItems="center">
                                    <Typography style={{ marginRight: '5px' }}>Show Entries:</Typography>
                                    <Dropdown
                                        options={showEntries}
                                        selectedValue={pageSize.toString()}
                                        handleChange={(event: any) => updateField(event)}
                                        width="90px"
                                        height="40px"
                                    />
                                </Box>
                                {companyOptions && companyOptions.length > 0 && (
                                    <Box sx={{ 
                                        marginLeft: '10px',marginTop:{xs:'5px'}
                                    }}>
                                        <Dropdown
                                            options={companyOptions}
                                            selectedValue={selectedCompany}
                                            handleChange={(e: any) => {
                                                const newValue = String(e.target.value);
                                                setSelectedCompany(newValue);
                                                localStorage.setItem('lastSelectedCompany', newValue);
                                            }}
                                            placeholder="Choose Company"
                                            label=" Choose Company"
                                            width="180px"
                                            height="40px"
                                        />
                                    </Box>
                                )}
                            </>
                        }
                        rightContent={
                            <>
                                <Box display="flex" alignItems="center" gap="10px">
                                    <TextField
                className="styled-textfield"
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={handleInputChange}
                placeholder="Search by Vehicle Number"
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        handleSearchClick();
                    }
                }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton onClick={handleSearchClick} edge="end">
                                <SearchIcon sx={{ color: 'black' }} />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
                                    <Button 
                                        className="custom-button" 
                                        onClick={handleClickOpen}
                                        variant="contained"
                                    >
                                        Add Vehicle
                                    </Button>
                                    <IconButton 
                                        onClick={exportToExcel}
                                        color="primary"
                                    >
                                        <DownloadIcon />
                                    </IconButton>
                                </Box>
                            </>
                        }
                    />
                </div>

                <Box 
                    className="table-container custom-data-grid" 
                    onScroll={handleScroll}
                    sx={{ 
                        background: isMobile ? 'linear-gradient(45deg, black, rgb(237, 27, 27))' : 'none',
                        marginLeft: { xs: '10px', sm: '180px' }, 
                        marginRight: '40px', 
                        position: 'relative', 
                        height: isMobile ? 'calc(100vh - 200px)' : '500px', 
                        overflowY: 'auto'
                    }}
                >
                    {isMobile ? (
                        <MobileVehicleList rowData={rows} />
                    ) : (
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            sx={{ flex: 1, minWidth: 0, '& .MuiDataGrid-cell:focus': { outline: 'none' } }}
                            getRowHeight={() => 'auto'}
                            disableRowSelectionOnClick
                            hideFooterPagination
                        />
                    )}
                </Box>

                {!isMobile && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
                        <Newpagination 
                            rows={totalRecords} 
                            pageSize={pageSize} 
                            page={page} 
                            handlePageChange={handlePageClick} 
                        />
                    </div>
                )}

                <NavBar selected='Vehicles' />
                <AddVehicleModal
                    addVehicleModalOpen={isAddVehicleOpen}
                    handleCloseAddVehicle={handleCloseAddVehicle}
                    companyOptions={companyOptions}
                    isPlatformUser={isPlatformUser}
                    isSTMSSelected={isSTMSSelected}
                />
                <EditVehicleModal
                    open={openModal}
                    onClose={handleCloseModal}
                    vehicle={selectedVehicle}
                    tab={activeTab?.toLowerCase()}
                    isPlatformUser={isPlatformUser}
                    isSTMSSelected={isSTMSSelected}
                />
                <DocumentsModal
                    open={documentsModal}
                    onClose={handleCloseDetailsModal}
                    vehicle={selectedVehicle}
                />
                <QueryWidget />
            </>
        );
    }

    return (
        <>   
            <Header/>
            <div style={{ marginTop: "70px" }}>
                <Heading
                    title="Vehicles"
                    page='vehicles'
                    closeIcon="false"
                    leftContent={
                        <>
                            <Box display="flex" alignItems="center">
                                <Typography style={{ marginRight: '5px' }}>Show Entries:</Typography>
                                <Dropdown
                                    options={showEntries}
                                    selectedValue={pageSize.toString()}
                                    handleChange={(event: any) => updateField(event)}
                                    width="90px"
                                    height="40px"
                                />
                            </Box>

                            {hasWarehouseFeature && (
                                <Box sx={{ 
                                    marginLeft: '10px', 
                                    marginTop: { xs: '10px', sm: '10px', md: '10px', lg: '0px' } 
                                }}>
                                    <Dropdown
                                        options={warehouseOptions}
                                        selectedValue={selectedWarehouse?.id || ''}
                                        handleChange={(event: any) => handleWarehouseChange(event)}
                                        placeholder="Choose Warehouse"
                                        label={"Choose Warehouse"}
                                        width="190px"
                                        height="40px"
                                    />
                                </Box>
                            )}
                        </>
                    }
                    rightContent={
                        <>
                            <Box display="flex" alignItems="center" gap="10px">
                                <TextField
                                    className="styled-textfield"
                                    variant="outlined"
                                    size="small"
                                    value={searchTerm}
                                    onChange={handleInputChange}
                                    placeholder="Search by Vehicle Number"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSearchClick();
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleSearchClick} edge="end">
                                                    <SearchIcon sx={{ color: 'black' }} />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                            <Box sx={{ 
                                marginTop: { xs: '10px', sm: '0px', md: '10px', lg: '0px' } 
                            }}>
                                <Button className="custom-button" onClick={handleClickOpen}>
                                    Add Vehicle
                                </Button>
                                <IconButton 
                                    sx={{ marginLeft: { xs: '10px', sm: '0px', md: '10px' }, color: 'black' }} 
                                    onClick={exportToExcel}
                                >
                                    <DownloadIcon />
                                </IconButton>
                            </Box>
                        </>
                    }
                />
                <AddVehicleModal
                    addVehicleModalOpen={isAddVehicleOpen}
                    handleCloseAddVehicle={handleCloseAddVehicle}
                    isPlatformUser={isPlatformUser}
                    isSTMSSelected={isSTMSSelected}
                />
            </div>

            <Box sx={{ marginLeft: { xs: '10px', sm: '180px' } }}>
                <StatusFilterTabs 
                    tabs={['Active', 'Inactive']}
                    activeTab={activeTab} 
                    onTabChange={handleTabChange} 
                />
            </Box>

            <Box 
                className="table-container custom-data-grid" 
                onScroll={handleScroll}
                sx={{ 
                    background: isMobile ? 'linear-gradient(45deg, black, rgb(237, 27, 27))' : 'none',
                    marginLeft: { xs: '0px', sm: '180px' },
                    marginTop: '10px', 
                    marginRight: '40px', 
                    position: 'relative', 
                    height: isMobile ? 'calc(100vh - 200px)' : '500px', 
                    overflowY: 'auto'
                }}
            >
                {isMobile ? (
                    <MobileVehicleList rowData={rows} />
                ) : (
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        sx={{ flex: 1, minWidth: 0, '& .MuiDataGrid-cell:focus': { outline: 'none' } }}
                        getRowHeight={() => 'auto'}
                        rowCount={totalRecords}
                        autoHeight={false}
                        disableRowSelectionOnClick
                        disableColumnResize
                        hideFooterPagination
                        classes={{ columnHeader: 'red-header' }}
                    />
                )}
            </Box>

            {!isMobile && (
                <div style={{ marginLeft: '50%', marginTop: '8px' }}> 
                    <Newpagination
                        rows={totalRecords}
                        pageSize={pageSize}
                        page={page}
                        handlePageChange={handlePageClick}
                    />
                </div>
            )}

            <NavBar selected='Vehicles' />
            <EditVehicleModal
                open={openModal}
                onClose={handleCloseModal}
                vehicle={selectedVehicle}
                tab={activeTab?.toLowerCase()}
                isPlatformUser={isPlatformUser}
                isSTMSSelected={isSTMSSelected}
            />
            <DocumentsModal
                open={documentsModal}
                onClose={handleCloseDetailsModal}
                vehicle={selectedVehicle}
            />

            <QueryWidget />
        </>
    );
};

export default Vehicles;